module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	var Promise = fox.RSVP.Promise;

	fox.registerWidget('HeaderSwipeSlider', {

		configure: function (options) {

			this.registerOptions('', {
				container: '.header-block-wrapper',
				template: 'swipe_header',
				manualRender: true,
				imagesPaths: [],
				handleDom: {
					gotoSlide: {
						target: '.slider-pager [data-index]',
						event: 'click',
						callback: '_handlePagerClick'
					}
				}
			});

			this.callParent('configure', arguments);

		},

		activating: function(params) {
			this.callParent('activating', arguments);

			if (this._readyToRender) {
				this.render();
			}
		},

		init: function () {
			this._images = this.getOption('imagesPaths');

			if (fox.isFunction(this._images)) {
				this._images = this._images();
			}

			this.fakeImages = null;

			this.handleEvent('@root ~.Layout_Home', 'windowResize', function () {
				this.rebuild();
			}.bind(this));

			this.callParent('init', arguments);
		},

		render: function () {
			if (this.checkLoadedImagesCount()) return this.callParent('render', arguments);

			return this.prepareImages()
				.then(this.renderSlider.bind(this))
				.then(this.callParent.bind(this, 'render', arguments));
		},

		renderSlider: function (paths) {
			paths = paths.filter(Boolean);
			var arr = paths || [];
			this.imagesCounter = paths.length;

			if (fox.isArray(this.fakeImages)) {
				arr = this.fakeImages;
			}

			arr.sort(function (a, b) {
				return a.ind - b.ind;
			});

			if (fox.count(arr) > 0) {
				this.setTemplateOptions('paths', arr);
			}

			return this;
		},

		addedToDom: function () {
			this.rebuild();
		},

		build: function () {
			if ((this.fakeImages && this.fakeImages.length) || this.imagesCounter) {
				this.applySwipe();

				return this;
			}

			this.show();
		},

		applySwipe: function (argument) {
			this.swipe = window.Swipe(this.dom1('#swipe-wrapper'), {
				startSlide: 0,
				speed: 1000,
				auto: 5000,
				continuous: true,
				callback: function (ind, el) {
					this.markSlide(ind);
				}.bind(this)
			});
		},

		rebuild: function () {
			if (this.swipe) {
				this.swipe.kill();
			}

			this.build();
		},

		prepareImages: function () {

			if (!this._images.length) return false;

			return Promise.all(this._images.map(function (imgName, idx) {
				var url = imgName;

				return fox.image.create({url: url}).get().then(function (img) {
					if (img.width > 1 && img.height > 1) {
						return {ind: idx, src: url};
					}
					return false;
				});
			}).filter(function (url) { return url}) );
		},

		markSlide: function (ind) {
			var slide = this.dom1('.slider-pager [data-index="' + (ind-1) + '"]');

			fox.each(this.dom('.slider-pager [data-index]'), function (elm) {
				var elmInd = fox.dom.wrap(elm).attr('data-index');

				if (+elmInd === ind) {
					fox.dom.addClass('active', elm);

					return;
				}

				fox.dom.removeClass('active', elm);
			}, this);
		},

		next: function () {
			this.swipe.next();
		},

		prev: function () {
			this.swipe.prev();
		},

		slide: function (ind) {
			this.swipe.slide(ind);
		},

		_handlePagerClick: function (elm, alias, w, e) {
			e.stopPropagation();
			e.preventDefault();

			var ind  = window.parseInt(fox.dom.wrap(elm).attr('data-index'));

			this.slide(ind++);
		},

		checkLoadedImagesCount: function () {
			return this.imagesCounter === this._images.length;
		},

		show: function () {
			var elm = this.dom1('.header-images-slider');

			if (!elm) return;

			elm.style.visibility = 'visible';
		}

	}, 'Widget');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/headerSwipeSlider.js
// module id = 838
// module chunks = 4